import { DesktopOutlined, ShopOutlined } from '@ant-design/icons';
import { Modal, Row } from 'antd';

import { AddCouponCardComponent } from '../AddCouponCard/AddCouponCard.component';

interface CouponOption {
  title: string;
  route: string;
  icon: React.ReactNode;
  disabled?: boolean;
}

interface AddCouponModalProps {
  modalIsOpen: boolean;
  onCloseModal: () => void;
}

const CardCouponOptions: CouponOption[] = [
  {
    title: 'Produto físico',
    route: '/screens/physic/coupons/create',
    icon: <ShopOutlined />,
  },
  {
    title: 'Produto digital',
    route: '/screens/digital/coupons/create',
    icon: <DesktopOutlined />,
  },
];

export const AddCouponModal = ({
  modalIsOpen,
  onCloseModal,
}: AddCouponModalProps) => {
  return (
    <Modal
      title='Escolha um tipo de cupom'
      open={modalIsOpen}
      footer={false}
      onCancel={onCloseModal}
    >
      <Row gutter={[32, 32]}>
        {CardCouponOptions.map((card, index) => (
          <AddCouponCardComponent
            key={index}
            icon={card.icon}
            route={card.route}
            title={card.title}
            disabled={!!card.disabled}
          />
        ))}
      </Row>
    </Modal>
  );
};
